import api from '../../../../api.js';
import mails from './mailing.js';

export default async function(values) {
  try {
    const mail = Object.values(mails).filter((val) => val.value === parseInt(values.mail, 10))[0];
    let message = mail.message;

    if(mail.replace.length > 0) {
      for(const i in mail.replace) {
        message = message.replace(mail.replace[i][0], values?.[mail.replace[i][1]] ?? '');
      }
    }

    if(mail) {
      await api.users.moderation.add({
        user: values.user.id,
        freelance: values.freelance.id,
        description: `Mail envoyé (${mail.subject})`,
      });

      window.location.href = `mailto:${values.email}?subject=${mail.subject}&body=${encodeURIComponent(message)}`;
    } else {
      // @todo show message
    }
  } catch(e) {
    console.log(e);
  }
}